import { compose, withProps } from 'recompose'
import { createWithLazyEntities } from '@infotech/lib-api-middleware'

import {
  TOIR_ISSUE_TYPES_SCHEMA_NAME,
  toirIssueTypesSelector,
  toirIssueTypesApiActions,
  toirIssueTypesEntitiesSelector,
} from 'api/toirIssueTypes'

export const toirIssueTypesDataPropName = `toirIssueTypes`

const withToirIssueTypes = createWithLazyEntities({
  entitiesSelector: toirIssueTypesEntitiesSelector,
  dataSelector    : toirIssueTypesSelector,
  schemaName      : TOIR_ISSUE_TYPES_SCHEMA_NAME,
  fetchApiAction  : toirIssueTypesApiActions.fetch,
  dataPropName    : toirIssueTypesDataPropName,
})


export const toirIssueTypesTransport = compose(
  withProps({
    query: {
      limit: -1,
    },
  }),
  withToirIssueTypes
)
